import { createFilterOptions } from "@material-ui/lab/useAutocomplete"
import CountryConfig from "../models/braintree/CountryConfig"
import {matchSorter} from 'match-sorter';

const filters = {
  dialingCodes: (options : CountryConfig[], { inputValue }) =>  matchSorter(options, inputValue,{keys: ['label', 'dialingCode']}),
  countryFilter: (options : CountryConfig[], { inputValue }) => matchSorter(options, inputValue,{keys: ['label']})
}

export default filters